/* eslint-disable @typescript-eslint/no-explicit-any */
import { Dispatch } from "redux";
import { resetApp } from "../redux/store";
import { resetClientStorage } from "../utils/resetClientStorage";

export const handleLogout = async (dispatch: Dispatch, removeCookie: any) => {
  await resetClientStorage({ preserveLocalStorageKeys: ["language"] });
  dispatch(resetApp());
  removeCookie("authToken");
  window.location.href = import.meta.env.VITE_LANDING_APP_URL;
};
